import { Component } from '@angular/core';
import { ChatbotStateService } from 'src/app/_services/chatbot/chatbot-state.service';

/**
 * ChatbotButtonComponent — Botón flotante (FAB) del chatbot.
 *
 * Visible en todas las páginas autenticadas. Al hacer clic abre o cierra
 * el panel del chatbot mediante el ChatbotStateService.
 *
 * Requisitos: 5.2, 5.3, 5.10
 */
@Component({
  selector: 'app-chatbot-button',
  templateUrl: './chatbot-button.component.html',
  styleUrls: ['./chatbot-button.component.css']
})
export class ChatbotButtonComponent {

  /** Controla si el panel del chatbot está abierto. */
  isPanelOpen = false;

  constructor(private chatbotState: ChatbotStateService) {}

  /**
   * Alterna la visibilidad del panel del chatbot.
   * Req 5.3: al hacer clic en el FAB se abre el panel de chat.
   */
  togglePanel(): void {
    this.isPanelOpen = !this.isPanelOpen;
    if (!this.isPanelOpen) {
      this.chatbotState.reset();
    }
  }
}
